const DateSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2.5 3.5H13.5C13.7761 3.5 14 3.72386 14 4V14C14 14.2761 13.7761 14.5 13.5 14.5H2.5C2.22386 14.5 2 14.2761 2 14V4C2 3.72386 2.22386 3.5 2.5 3.5Z"
        stroke="#333333"
      />
      <path
        d="M4.125 2C4.33207 2.00002 4.49996 2.16794 4.5 2.375V3.625C4.5 3.83211 4.33211 4 4.125 4C3.91789 4 3.75 3.83211 3.75 3.625V2.375C3.75004 2.16793 3.91792 2 4.125 2Z"
        fill="#D9D9D9"
        stroke="#333333"
      />
      <path
        d="M11.875 2C12.0821 2 12.25 2.16789 12.25 2.375V3.625C12.25 3.83211 12.0821 4 11.875 4C11.6679 4 11.5 3.83211 11.5 3.625V2.375C11.5 2.16789 11.6679 2 11.875 2Z"
        fill="#D9D9D9"
        stroke="#333333"
      />
      <path
        d="M8 2C8.20706 2.00002 8.37494 2.16796 8.375 2.375V3.625C8.375 3.83211 8.20711 4 8 4C7.79289 4 7.625 3.83211 7.625 3.625V2.375L7.63281 2.2998C7.66769 2.12881 7.8187 2 8 2Z"
        fill="#D9D9D9"
        stroke="#333333"
      />
      <path
        d="M4.19531 7H11.8047C11.8434 7 11.875 7.0316 11.875 7.07031C11.8749 7.10893 11.8433 7.14062 11.8047 7.14062H4.19531C4.15667 7.14062 4.12511 7.10893 4.125 7.07031C4.125 7.04127 4.14281 7.0165 4.16797 7.00586L4.19531 7Z"
        fill="#D9D9D9"
        stroke="#333333"
      />
    </svg>
  );
};

export default DateSvg;
